/**
 *
 * @param {object} param0
 * @param {import('@fs/zion-tree-types').TreeId} [param0.treeId]
 * @param {string} [param0.pedigreeType]
 * @param {string} [param0.mePersonId]
 * @returns {string}
 */

export default function getTreeUrl({ treeId, pedigreeType, mePersonId }) {
  const pedigreeTypePath = pedigreeType ? `/${pedigreeType}` : ''
  const mePersonIdPath = mePersonId ? `/${mePersonId}` : ''
  const treeIdPath = treeId ? `treeId=${treeId}` : ''
  return `/tree/pedigree${pedigreeTypePath}${mePersonIdPath}/?${treeIdPath}`
}
